// extracted by mini-css-extract-plugin
module.exports = {"CookieConcentLink":"CookieConcentBar-module--CookieConcentLink--A6IXS"};